import React, { useState } from 'react';
import EditExperienceModal from './EditExperienceModal';

const ClientExperience = ({ submissions, onRefresh }) => {
    const [editingSubmissionId, setEditingSubmissionId] = useState(null);
    const [editingExperience, setEditingExperience] = useState(null);

    // Extract experience info from wizard submissions
    const experienceData = submissions
        .map(sub => ({ data: sub.experience_info, submissionId: sub.id }))
        .filter(item => item.data && (Array.isArray(item.data) ? item.data.length > 0 : Object.keys(item.data).length > 0));

    if (experienceData.length === 0) {
        return (
            <div className="bg-gray-800 border border-gray-700 rounded-lg shadow-lg overflow-hidden">
                <div className="bg-gray-900/50 p-4 border-b border-gray-700">
                    <h3 className="text-lg font-bold text-white uppercase tracking-wider">💼 Work Experience</h3>
                </div>
                <div className="p-8 text-center text-gray-400">
                    No work experience information available from wizard submissions.
                </div>
            </div>
        );
    }

    return (
        <>
            {editingSubmissionId && editingExperience && (
                <EditExperienceModal
                    submissionId={editingSubmissionId}
                    experienceData={editingExperience}
                    onClose={() => {
                        setEditingSubmissionId(null);
                        setEditingExperience(null);
                    }}
                    onSave={onRefresh}
                />
            )}

            <div className="bg-gray-800 border border-gray-700 rounded-lg shadow-lg overflow-hidden">
                <div className="bg-gray-900/50 p-4 border-b border-gray-700">
                    <h3 className="text-lg font-bold text-white uppercase tracking-wider">💼 Work Experience</h3>
                </div>
                <div className="p-6 space-y-6">
                    {experienceData.map((item, submissionIndex) => {
                        const experiences = Array.isArray(item.data) ? item.data : [item.data];

                        return experiences.map((exp, expIndex) => (
                            <div key={`${submissionIndex}-${expIndex}`} className="p-4 bg-gray-700/50 rounded border border-gray-600 relative">
                                {item.submissionId && expIndex === 0 && (
                                    <button
                                        onClick={() => {
                                            setEditingSubmissionId(item.submissionId);
                                            setEditingExperience(item.data);
                                        }}
                                        className="absolute top-4 right-4 text-xs px-3 py-1.5 rounded bg-blue-600 text-white border border-blue-500 hover:bg-blue-700"
                                    >
                                        ✏️ Edit
                                    </button>
                                )}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    {exp.jobTitle && (
                                        <div>
                                            <div className="text-xs text-gray-500 uppercase tracking-wider mb-1">Job Title</div>
                                            <div className="text-white font-mono font-bold">{exp.jobTitle}</div>
                                        </div>
                                    )}
                                    {exp.company && (
                                        <div>
                                            <div className="text-xs text-gray-500 uppercase tracking-wider mb-1">Company</div>
                                            <div className="text-white font-mono">{exp.company}</div>
                                        </div>
                                    )}
                                    {exp.totalExperience && (
                                        <div>
                                            <div className="text-xs text-gray-500 uppercase tracking-wider mb-1">Total Experience</div>
                                            <div className="text-white font-mono">{exp.totalExperience}</div>
                                        </div>
                                    )}
                                    {exp.startDate && (
                                        <div>
                                            <div className="text-xs text-gray-500 uppercase tracking-wider mb-1">Start Date</div>
                                            <div className="text-white font-mono">{exp.startDate}</div>
                                        </div>
                                    )}
                                    {exp.endDate && (
                                        <div>
                                            <div className="text-xs text-gray-500 uppercase tracking-wider mb-1">End Date</div>
                                            <div className="text-white font-mono">{exp.endDate}</div>
                                        </div>
                                    )}
                                    {exp.currentlyWorking !== undefined && (
                                        <div>
                                            <div className="text-xs text-gray-500 uppercase tracking-wider mb-1">Currently Working</div>
                                            <div className="text-white font-mono">{exp.currentlyWorking ? 'Yes' : 'No'}</div>
                                        </div>
                                    )}
                                    {exp.industry && (
                                        <div>
                                            <div className="text-xs text-gray-500 uppercase tracking-wider mb-1">Industry</div>
                                            <div className="text-white font-mono">{exp.industry}</div>
                                        </div>
                                    )}
                                    {exp.location && (
                                        <div>
                                            <div className="text-xs text-gray-500 uppercase tracking-wider mb-1">Location</div>
                                            <div className="text-white font-mono">{exp.location}</div>
                                        </div>
                                    )}
                                </div>

                                {exp.description && (
                                    <div className="mt-4">
                                        <div className="text-xs text-gray-500 uppercase tracking-wider mb-1">Description</div>
                                        <div className="text-sm text-gray-300">{exp.description}</div>
                                    </div>
                                )}

                                {/* Display all other fields as JSON */}
                                {Object.keys(exp).length > 8 && (
                                    <details className="mt-4">
                                        <summary className="text-xs text-blue-400 cursor-pointer hover:text-blue-300">View All Fields</summary>
                                        <pre className="mt-2 p-3 bg-gray-900 rounded text-xs text-gray-300 overflow-auto">
                                            {JSON.stringify(exp, null, 2)}
                                        </pre>
                                    </details>
                                )}
                            </div>
                        ));
                    })}
                </div>
            </div>
        </>
    );
};

export default ClientExperience;
